import { render, staticRenderFns } from "./BotoesDeAcoesRastreabilidade.vue?vue&type=template&id=515fafa7&scoped=true&lang=pug"
import script from "./BotoesDeAcoesRastreabilidade.vue?vue&type=script&lang=js"
export * from "./BotoesDeAcoesRastreabilidade.vue?vue&type=script&lang=js"
import style0 from "./BotoesDeAcoesRastreabilidade.vue?vue&type=style&index=0&id=515fafa7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515fafa7",
  null
  
)

export default component.exports